import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { useLanguage } from '../../context/LanguageContext';

const { FiInstagram, FiMail, FiMapPin } = FiIcons;

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-secondary py-16">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center md:text-left">
          {/* Brand Column */}
          <div>
            <h3 className="font-serif text-2xl mb-4">Nailed by <span className="italic">Liana</span></h3>
            <p className="text-text-light text-sm leading-relaxed max-w-xs mx-auto md:mx-0">
              {t('footer.description')}
            </p>
          </div>

          {/* Navigation Column */}
          <div className="flex flex-col items-center md:items-start gap-4">
            <h4 className="uppercase tracking-widest text-sm font-semibold mb-2">{t('footer.explore')}</h4>
            <Link to="/services" className="text-text-light hover:text-text-dark text-sm transition-colors">{t('nav.services')}</Link>
            <Link to="/courses" className="text-text-light hover:text-text-dark text-sm transition-colors">{t('footer.nailCourses')}</Link>
            <Link to="/portfolio" className="text-text-light hover:text-text-dark text-sm transition-colors">{t('nav.portfolio')}</Link>
            <Link to="/contact" className="text-text-light hover:text-text-dark text-sm transition-colors">{t('nav.bookAppointment')}</Link>
          </div>

          {/* Contact Column */}
          <div className="flex flex-col items-center md:items-start gap-4">
            <h4 className="uppercase tracking-widest text-sm font-semibold mb-2">{t('footer.connect')}</h4>
            <a href="#" className="flex items-center gap-2 text-text-light hover:text-text-dark text-sm transition-colors">
              <SafeIcon icon={FiInstagram} /> @nailedbyliana
            </a>
            <div className="flex items-center gap-2 text-text-light text-sm">
              <SafeIcon icon={FiMapPin} /> Montreal, QC
            </div>
            <div className="flex items-center gap-2 text-text-light text-sm">
              <SafeIcon icon={FiMail} /> hello@nailedbyliana.com
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-text-dark/10 mt-12 pt-8 text-center text-xs text-text-light uppercase tracking-widest">
          &copy; {new Date().getFullYear()} Nailed by Liana. {t('footer.rights')}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
